module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAuMjUiIGN5PSIyMC4yNSIgcj0iMTYuMjUiIGZpbGw9IiM0RkE0NjIiLz4KPGNpcmNsZSBjeD0iMjAuMjUiIGN5PSIyMC4yNSIgcj0iMTcuOTQyNyIgc3Ryb2tlPSIjNEZBNDYyIiBzdHJva2Utb3BhY2l0eT0iMC4yIiBzdHJva2Utd2lkdGg9IjMuMzg1NDIiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/Credit.svg
// module id = 8pCj
// module chunks = 0